import { Exception } from './exception';

export class AssertionException extends Exception {
  // Force details to be filled
  // eslint-disable-next-line @typescript-eslint/no-useless-constructor
  constructor(details: string) {
    super(details);
  }
}
